import * as React from "react";
import { eBranches } from "sb-helpers";
import { Scoreboards } from "../../../../constants";
import { Scoreboard } from "../Scoreboard";
import { TeamsScore } from "../TeamsScore";
export const Score = (props) => Scoreboards[eBranches[props.sportId]]
    ? React.createElement(Scoreboard, Object.assign({}, props.scoreboard))
    : React.createElement(TeamsScore, { score1: props.score1, score2: props.score2, componentPrefix: props.componentPrefix });
//# sourceMappingURL=Score.js.map